import React from 'react';
import { Input } from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';

const WithPlaceholder = ({ intl, placeholder: id = '', defaultMessage, ...rest }) => {
  const placeholder = intl.formatMessage({ id, defaultMessage });
  return <Input {...rest} placeholder={placeholder} />;
};

WithPlaceholder.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(WithPlaceholder);
